export default "__VITE_ASSET__0gas2Kkd__"